// extracted by mini-css-extract-plugin
module.exports = {"form":"PayModal_style_form__iDSf-"};